<template>
	<div id="container">
		<slot></slot>
		<div class="zcqkzl">
			<span class="apptitle">资产情况总览</span>
			<div class="zcqkzl_data">
				<div style="padding-left: 20px;padding-top: 10px;">
					<div class="zcqkzl_data_left zcqkzl_data_left_img1" @click="xgleixingtop(1)">
						<span class="zcqkzl_data_left_val" style="text-align: left;padding-left: 30px;">{{getAllCertAssetCountval.homeCount}}</span>
						<span class="zcqkzl_data_left_title" style="text-align: left;padding-left: 30px;">经营性资产</span>
					</div>
					<div class="zcqkzl_data_left zcqkzl_data_left_img2" @click="xgleixingtop(4)">
						<span class="zcqkzl_data_left_val" style="text-align: right;padding-right: 30px;">{{getAllCertAssetCountval.flatCount}}</span>
						<span class="zcqkzl_data_left_title" style="text-align: right;padding-right: 30px;">人才公寓</span>
					</div>
					<div class="zcqkzl_data_left zcqkzl_data_left_img3" @click="xgleixingtop(5)">
						<span class="zcqkzl_data_left_val" style="text-align: left;padding-left: 30px;">{{getAllCertAssetCountval.ensureCount}}</span>
						<span class="zcqkzl_data_left_title" style="text-align: left;padding-left: 30px;">保障房</span>
					</div>
					<div class="zcqkzl_data_left zcqkzl_data_left_img4" @click="xgleixingtop(6)">
						<span class="zcqkzl_data_left_val" style="text-align: right;padding-right: 30px;">{{getAllCertAssetCountval.publicRentCount}}</span>
						<span class="zcqkzl_data_left_title" style="text-align: right;padding-right: 30px;">公租房</span>
					</div>
					<div class="zcqkzl_data_left_img5">
						<span class="zcqkzl_data_left_val" style="padding-top: 10px;">{{getAllCertAssetCountval.certCount}}</span>
						<span class="zcqkzl_data_left_title">产证总数</span>
					</div>
				</div>
			</div>

			<!-- 租赁分析 -->
			<div class="shuzulvs">
				<span class="apptitle">租赁分析</span>
				<div class="zulin">
					<div class="zulin_title">
						总租赁资产数：<span class="zulin_title_val">795个</span> 
					</div>
					<div class="zulin_baifenbi">
						<div class="zulin_baifenbi_one">
							<el-progress :text-inside="true" :stroke-width="16" :percentage="bfb1"></el-progress>
						</div>
						<span class="zulin_baifenbi_title">经营性资产({{getDataVLeaseCountval.homeLeaseCount}}/{{getDataVLeaseCountval.homeCount}})</span>
					</div>
					<div class="zulin_baifenbi">
						<div class="zulin_baifenbi_one">
							<el-progress :text-inside="true" :stroke-width="16" :percentage="bfb2"></el-progress>
						</div>
						<span class="zulin_baifenbi_title">人才公寓租赁({{getDataVLeaseCountval.flatLeaseCount}}/{{getDataVLeaseCountval.flatCount}})</span>
					</div>
					<div class="zulin_baifenbi">
						<div class="zulin_baifenbi_one">
							<el-progress :text-inside="true" :stroke-width="16" :percentage="bfb3"></el-progress>
						</div>
						<span class="zulin_baifenbi_title">保障房租赁({{getDataVLeaseCountval.ensureLeaseCount}}/{{getDataVLeaseCountval.ensureCount}})</span>
					</div>
					<div class="zulin_baifenbi">
						<div class="zulin_baifenbi_one">
							<el-progress :text-inside="true" :stroke-width="16" :percentage="bfb4"></el-progress>
						</div>
						<span class="zulin_baifenbi_title">公租房租赁({{getDataVLeaseCountval.publicRentLeaseCount}}/{{getDataVLeaseCountval.publicRentCount}})</span>
					</div>
				</div>
			</div>
			

			<!-- 流拍 -->
			<span class="apptitle">拍租情况</span>
			<div class="liupai_one">
				<span class="liupai_name">当月拍租数量</span>
				<span class="liupai_val">{{getLeftAssetLeaseInfoval.monthlyAuctionNum}}个</span>
			</div>
			<div class="liupai_one">
				<span class="liupai_name">当月成交数量</span>
				<span class="liupai_val">{{getLeftAssetLeaseInfoval.monthlyTradNum}}个</span>
			</div>
			<div class="liupai_one">
				<span class="liupai_name">当月流拍数量</span>
				<span class="liupai_val">{{getLeftAssetLeaseInfoval.monthlyStreamNum}}个</span>
			</div>


		</div>

		<div class="zcqkzlyyzx">
			<span class="apptitle" style="font-size: 24px;">资产数据可视化运营中心</span>
			<div style="text-align: left;padding-top: 20px;">
				<el-select v-model="leixing_val" placeholder="请选择">
					<el-option v-for="item in leixing" :key="item.id" :label="item.label" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="lstatus_val" placeholder="请选择" style="margin-left: 20px;">
					<el-option v-for="item in lstatus" :key="item.id" :label="item.label" :value="item.id">
					</el-option>
				</el-select>
				<el-input v-model="soso" placeholder="关键词搜索资产" style="margin-left: 20px;width: 240px;"></el-input>
				<el-button type="primary" style="margin-left: 20px;width: 140px;" @click="sosofun()">搜 索</el-button>
			</div>

		</div>

		<div class="zcyj">
			<span class="apptitle"  style="color: #fff;">资产预警情况</span>

			<div id="maplistddd">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="欠租预警" name="first">
						<el-table :data="tableData1" style=" overflow-y: auto !important; position: relative;height: 400px !important;">
							<el-table-column prop="name" label="资产名称" >
							</el-table-column>
							<el-table-column prop="countPlan" label="欠租期数" sortable>
							</el-table-column>
							<el-table-column prop="address" label="操作">
								<template slot-scope="scope">
									<el-button size="mini"  @click="handleClick1(scope.row.id)">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
					<el-tab-pane label="到期预警" name="second">
						<el-table :data="tableData2"  style=" overflow-y: auto !important; position: relative;height: 400px !important;">
							<el-table-column prop="name" label="资产名称" >
							</el-table-column>
							<el-table-column prop="endTime" label="到期时间" sortable>
							</el-table-column>
							<el-table-column prop="address" label="操作">
								<template slot-scope="scope">
									<el-button size="mini"  @click="handleClick2(scope.row.id)">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		
		
		<div class="shuzulv">
			
			<span class="apptitle">租金营收情况</span>
			<div class="zulin">
				<div class="zulin_title">
					总租金：<span class="zulin_title_val">{{getDataVRentCountval.isPayed}}/{{getDataVRentCountval.allCount}}（万元）</span> 
				</div>
				<div class="zulin_baifenbi">
					<div class="zulin_baifenbi_one">
						<el-progress  :text-inside="true" :stroke-width="16" :percentage="bfb11"></el-progress>
					</div>
					<span class="zulin_baifenbi_title">经营性资产({{getDataVRentCountval.homeIsPayed}}/{{getDataVRentCountval.homeAllCount}})（万元）</span>
				</div>
				<div class="zulin_baifenbi">
					<div class="zulin_baifenbi_one">
						<el-progress   :text-inside="true" :stroke-width="16" :percentage="bfb22"></el-progress>
					</div>
					<span class="zulin_baifenbi_title">人才公寓租赁({{getDataVRentCountval.flagIsPayed}}/{{getDataVRentCountval.flatAllCount}})（万元）</span>
				</div>
				<div class="zulin_baifenbi">
					<div class="zulin_baifenbi_one">
						<el-progress   :text-inside="true" :stroke-width="16" :percentage="bfb33"></el-progress>
					</div>
					<span class="zulin_baifenbi_title">保障房租赁({{getDataVRentCountval.ensureIsPayed}}/{{getDataVRentCountval.ensureAllCount}})（万元）</span>
				</div>
				<div class="zulin_baifenbi">
					<div class="zulin_baifenbi_one">
						<el-progress   :text-inside="true" :stroke-width="16"  :percentage="bfb44"></el-progress>
					</div>
					<span class="zulin_baifenbi_title">公租房租赁({{getDataVRentCountval.publicRentIsPayed}}/{{getDataVRentCountval.publicRentAllCount}})（万元）</span>
				</div>
			</div>
			
		</div>
		
		
		<el-dialog title="详情" :visible.sync="showDialog">
		
			<el-descriptions title="租赁详情">
				<el-descriptions-item label="资产名称">{{getAssetDetailsval.name}}</el-descriptions-item>
				<el-descriptions-item label="产权名称">{{getAssetDetailsval.certName}}</el-descriptions-item>
				<el-descriptions-item label="	证载用途">{{getAssetDetailsval.certUsage}}</el-descriptions-item>
				<el-descriptions-item label="	权利性质">{{getAssetDetailsval.property}}</el-descriptions-item>
				<el-descriptions-item label="	产权单位">{{getAssetDetailsval.obligee}}</el-descriptions-item>
				<el-descriptions-item label="资产账面值">{{getAssetDetailsval.bookValue}}</el-descriptions-item>
				<el-descriptions-item label="	地段">{{getAssetDetailsval.communityName}}</el-descriptions-item>
				<el-descriptions-item label="	委托时间">{{getAssetDetailsval.entrustTime}}</el-descriptions-item>
				<el-descriptions-item label="	添加时间">{{getAssetDetailsval.addTime}}</el-descriptions-item>
				<el-descriptions-item label="	水电情况">{{getAssetDetailsval.electricWater}}</el-descriptions-item>
				<el-descriptions-item label="	电表号">{{getAssetDetailsval.electric}}</el-descriptions-item>
				<el-descriptions-item label="	水表号">{{getAssetDetailsval.water}}</el-descriptions-item>
				<el-descriptions-item label="	面积">{{getAssetDetailsval.space}}㎡</el-descriptions-item>
				<el-descriptions-item label="	附属用房面积">{{getAssetDetailsval.roomSpace}}㎡</el-descriptions-item>
				<el-descriptions-item label="	拍租次数">{{getAssetDetailsval.auctionTimes}}</el-descriptions-item>
				<el-descriptions-item label="	备注">{{getAssetDetailsval.note}}</el-descriptions-item>
			</el-descriptions>
		
			<el-descriptions title="租赁详情" v-if="leaseIdDialog">
				<el-descriptions-item label="租期区间">{{getLeaseDetailsval.dateSection}}</el-descriptions-item>
				<!-- <el-descriptions-item label="租赁规则">{{getAssetDetailsval.templateId}}</el-descriptions-item> -->
				<el-descriptions-item label="每期应缴(元)">{{getLeaseDetailsval.monthlyRent}}</el-descriptions-item>
				<el-descriptions-item label="履约保证金（元）">{{getLeaseDetailsval.deposit}}</el-descriptions-item>
				<el-descriptions-item label="租赁状态">
					<el-tag size="small" v-if="getLeaseDetailsval.state == -1">已取消</el-tag>
					<el-tag size="small" v-if="getLeaseDetailsval.state == 0">待租赁</el-tag>
					<el-tag size="small" v-if="getLeaseDetailsval.state == 1">已付款</el-tag>
					<el-tag size="small" v-if="getLeaseDetailsval.state == 2">合同已签署</el-tag>
					<el-tag size="small" v-if="getLeaseDetailsval.state == 3">已退租/到期</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="备注">{{getLeaseDetailsval.note}}</el-descriptions-item>
				<el-descriptions-item label="录入时间">{{getLeaseDetailsval.note}}</el-descriptions-item>
				<el-descriptions-item label="是否发生转租">{{ getLeaseDetailsval.isSub == 1?'是':'否' }}</el-descriptions-item>
			</el-descriptions>
		
		</el-dialog>
		
		
		<el-dialog title="详情" :visible.sync="showDialog2">
			<el-descriptions title="租赁详情">
				<el-descriptions-item label="租期区间">{{qzgetLeaseDetailsval.dateSection}}</el-descriptions-item>
				<!-- <el-descriptions-item label="租赁规则">{{getAssetDetailsval.templateId}}</el-descriptions-item> -->
				<el-descriptions-item label="每期应缴(元)">{{qzgetLeaseDetailsval.monthlyRent}}</el-descriptions-item>
				<el-descriptions-item label="履约保证金（元）">{{qzgetLeaseDetailsval.deposit}}</el-descriptions-item>
				<el-descriptions-item label="租赁状态">
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == -1">已取消</el-tag>
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == 0">待租赁</el-tag>
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == 1">已付款</el-tag>
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == 2">合同已签署</el-tag>
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == 3">已退租/到期</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="备注">{{qzgetLeaseDetailsval.note}}</el-descriptions-item>
				<el-descriptions-item label="录入时间">{{qzgetLeaseDetailsval.note}}</el-descriptions-item>
				<el-descriptions-item label="是否发生转租">{{ qzgetLeaseDetailsval.isSub == 1?'是':'否' }}
				</el-descriptions-item>
			</el-descriptions>
			<br />
			<el-descriptions title="租户信息">
				<el-descriptions-item label="姓名">{{qzgetLeaseDetailsval.tenantName}}</el-descriptions-item>
				<el-descriptions-item label="身份证">{{qzgetLeaseDetailsval.identity}}</el-descriptions-item>
				<el-descriptions-item label="联系方式">{{qzgetLeaseDetailsval.phone}}</el-descriptions-item>
			</el-descriptions>
		
			<br />
			<h3 style="text-align: left;">收租计划</h3>
			<el-table :data="getHistoryLeaseval" style="width: 100%">
				<el-table-column prop="monthlyRent" label="应付租金">
				</el-table-column>
				<el-table-column prop="dateSection" label="租期">
				</el-table-column>
				<!-- <el-table-column prop="address" label="支付状态">
		      </el-table-column> -->
				<!-- <el-table-column prop="address" label="支付时间">
			  </el-table-column> -->
				<el-table-column prop="arrear" label="欠租">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.arrear ==1" type="danger">已欠租</el-tag>
						<el-tag v-if="scope.row.arrear ==0">不欠租</el-tag>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="address" label="标记支付时间">
			  </el-table-column> -->
				<el-table-column prop="addTime" label="创建时间">
				</el-table-column>
			</el-table>
		
		</el-dialog>
		
		
		<el-dialog title="详情" :visible.sync="showDialog3">
			<el-descriptions title="租赁详情">
				<el-descriptions-item label="租期区间">{{qzgetLeaseDetailsval.dateSection}}</el-descriptions-item>
				<!-- <el-descriptions-item label="租赁规则">{{getAssetDetailsval.templateId}}</el-descriptions-item> -->
				<el-descriptions-item label="每期应缴(元)">{{qzgetLeaseDetailsval.monthlyRent}}</el-descriptions-item>
				<el-descriptions-item label="履约保证金（元）">{{qzgetLeaseDetailsval.deposit}}</el-descriptions-item>
				<el-descriptions-item label="租赁状态">
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == -1">已取消</el-tag>
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == 0">待租赁</el-tag>
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == 1">已付款</el-tag>
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == 2">合同已签署</el-tag>
					<el-tag size="small" v-if="qzgetLeaseDetailsval.state == 3">已退租/到期</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="备注">{{qzgetLeaseDetailsval.note}}</el-descriptions-item>
				<el-descriptions-item label="录入时间">{{qzgetLeaseDetailsval.note}}</el-descriptions-item>
				<el-descriptions-item label="是否发生转租">{{ qzgetLeaseDetailsval.isSub == 1?'是':'否' }}
				</el-descriptions-item>
			</el-descriptions>
			<br />
			<el-descriptions title="租户信息">
				<el-descriptions-item label="姓名">{{qzgetLeaseDetailsval.tenantName}}</el-descriptions-item>
				<el-descriptions-item label="身份证">{{qzgetLeaseDetailsval.identity}}</el-descriptions-item>
				<el-descriptions-item label="联系方式">{{qzgetLeaseDetailsval.phone}}</el-descriptions-item>
			</el-descriptions>
		</el-dialog>
		
		
	</div>

</template>
<script>
	import Vue from 'vue'
	import axios from 'axios'
	import {
		Message
	} from 'element-ui'
	import qs from 'qs'
	export default {
		data() {
			return {
				showDialog: false,
				showDialog2: false,
				showDialog3: false,
				leaseIdDialog:false,
				tableData1: [],
				tableData2: [],	
				activeName: 'first',
				soso: '',
				leixing: [{
					id: '',
					label: '所有类型'
				}, {
					id: 1,
					label: '经营性资产'
				}, {
					id: 4,
					label: '人才公寓'
				}, {
					id: 5,
					label: '公租房'
				}, {
					id: 6,
					label: '保障房'
				},  ],
				leixing_val: '',
				lstatus: [{
					id: '',
					label: '所有状态'
				}, {
					id: -1,
					label: '不可用'
				}, {
					id: 0,
					label: '无人竞拍'
				},{
					id: 1,
					label: '使用中'
				},  ],
				lstatus_val: '',
				mapdata: [],
				map: '',
				singerMarkerval:[],
				getAllCertAssetCountval:[],
				getLeftAssetLeaseInfoval:[],
				getDataVLeaseCountval:[],
				bfb1:0,bfb2:0,bfb3:0,bfb4:0,
				getAssetDetailsval:[],
				getLeaseDetailsval:[],
				qzgetLeaseDetailsval:[],
				getHistoryLeaseval:[],
				getDataVRentCountval:[],
				bfb11:0,bfb22:0,bfb33:0,bfb44:0,
				
				
				smap: null,
				smarkers: [], // 用于存储所有标记点的数组
				smarkerCluster: null // 用于存储聚合组件实例的变量
			}
		},
		components: {},
		mounted() {
			document.title='资产数据可视化运营中心'
			var that= this;
			// 初始化地图
			this.smap = new AMap.Map('container', {
			  center: [119.923602, 28.458587],
			  zoom: 11,
			  resizeEnable: true,
			  averageCenter: true,
			  mapStyle: "amap://styles/darkblue"
			});
			
			//获取所有坐标
			this.getAssetMap();
			//初始化资产情况总览
			this.getAllCertAssetCount();
			//资产租赁情况
			this.getLeftAssetLeaseInfo();
			//租赁分析
			this.getDataVLeaseCount();
			
			//租期到期提醒
			this.getOverDueLeaList();
			
			//右下角初始化
			this.getDataVRentCount();
		},
		methods: {
			
			sclickMarker(){
				console.log('ok')
			},
			
			//选择后直接获取
			xgleixingtop(e){
				this.leixing_val = e;
				// Message({message: '数据加载失败 请稍后重试',type: 'error',}) //success   error
				//切换类型调用搜索
				this.sosofun();
			},
			
			
			//打开资产详情
			getAssetDetails(e) {
				var that = this;
				that.showDialog = true;
				console.log(e)
				var urlss = localStorage.getItem('urlss');
				axios.post(urlss + '/dataV/getAssetDetails?assetId=' + e + '', {}).then(function(res) {
						that.getAssetDetailsval = res.data.result;
						// console.log(res.data.result.leaseId)
			
						if (res.data.result.leaseId != 0) {
							that.leaseIdDialog = true;
							axios.post(urlss + '/dataV/getLeaseDetails?leaseId=' + res.data.result.leaseId + '', {})
								.then(function(res) {
									that.getLeaseDetailsval = res.data.result;
								})
								.catch(function(error) {
									Message({
										message: res.data.message,
										type: 'error',
									}) //success   error
								});
						}else{
							that.leaseIdDialog = false;
						}
			
					})
					.catch(function(error) {
						Message({
							message: res.data.message,
							type: 'error',
						}) //success   error
					});
			
			},
			
			
			//右下角初始化
			getDataVRentCount(){
				var that = this;
				var urlss = localStorage.getItem('urlss');
				axios.post(urlss + '/dataV/getDataVRentCount', {})
					.then(function(res) {
						that.getDataVRentCountval = res.data.result;
						that.bfb11 =Number(that.qiubaifenbi(res.data.result.homeIsPayed, res.data.result.homeAllCount));
						that.bfb22 =Number(that.qiubaifenbi(res.data.result.flagIsPayed, res.data.result.flatAllCount));
						that.bfb33 =Number(that.qiubaifenbi(res.data.result.ensureIsPayed, res.data.result.ensureAllCount));
						that.bfb44 =Number(that.qiubaifenbi(res.data.result.publicRentIsPayed, res.data.result.publicRentAllCount));
					})
					.catch(function(error) {
						Message({
							message: error,
							type: 'error',
						}) //success   error
					});
							
							
			},
			
			//租期
			handleClick2(row) {
				console.log(row)
				var that = this;
				that.showDialog3 = true;
			
				var urlss = localStorage.getItem('urlss');
				axios.post(urlss + '/dataV/getLeaseDetails?leaseId=' + row + ' ', {})
					.then(function(res) {
						that.qzgetLeaseDetailsval = res.data.result;
						that.currentItemId = res.data.result.assetList[0].id;
					})
					.catch(function(error) {
						Message({
							message: res.data.message,
							type: 'error',
						}) //success   error
					});
			
			},
			
			
			//欠租
			handleClick1(row) {
				console.log(row)
				var that = this;
				that.showDialog2 = true;
				var urlss = localStorage.getItem('urlss');
				axios.post(urlss + '/dataV/getLeaseDetails?leaseId=' + row + ' ', {})
					.then(function(res) {
						that.qzgetLeaseDetailsval = res.data.result;
						that.currentItemId = res.data.result.assetList[0].id;
			
						//资产详情-获取该资产的历史租赁信息0
						axios.post(urlss + '/dataV/getHistoryLease?assetId=' + that.currentItemId +
								'&pageNum=1&pageSize=20', {})
							.then(function(res) {
								that.getHistoryLeaseval = res.data.result.list;
								//  that.currentItemId =res.data.result.assetList[0].id;
								console.log(res.data.result.list)
							})
							.catch(function(error) {
								Message({
									message: res.data.message,
									type: 'error',
								}) //success   error
							});
					})
					.catch(function(error) {
						Message({
							message: res.data.message,
							type: 'error',
						}) //success   error
					});
			
			},
			
			//租期到期提醒
			getOverDueLeaList() {
				var that = this;
				var urlss = localStorage.getItem('urlss');
				axios.post(urlss + '/dataV/getOverDueLeaList', {})
					.then(function(res) {
						that.workData = res.data.result;
					})
					.catch(function(error) {
						Message({
							message: res.data.message,
							type: 'error',
						}) //success   error
					});
			
			
				axios.post(urlss + '/dataV/getZuJinDaoQi', {})
					.then(function(res) {
						that.behaviorData = res.data.result;
					})
					.catch(function(error) {
						Message({
							message: res.data.message,
							type: 'error',
						}) //success   error
					});
			},
			
			//租期到期提醒
			getOverDueLeaList() {
				var that = this;
				var urlss = localStorage.getItem('urlss');
				
				//欠租
				axios.post(urlss + '/dataV/getZuJinDaoQi', {})
					.then(function(res) {
						that.tableData1 = res.data.result;
					})
					.catch(function(error) {
						Message({
							message: res.data.message,
							type: 'error',
						}) //success   error
					});
					
				axios.post(urlss + '/dataV/getOverDueLeaList', {})
					.then(function(res) {
						that.tableData2 = res.data.result;
					})
					.catch(function(error) {
						Message({
							message: res.data.message,
							type: 'error',
						}) //success   error
					});
			
				
			},
			
			//资产租赁情况
			getDataVLeaseCount() {
				var that = this;
				var urlss = localStorage.getItem('urlss');
				axios.post(urlss + '/dataV/getDataVLeaseCount', {})
					.then(function(res) {
						that.getDataVLeaseCountval = res.data.result;
						that.bfb1 =Number(that.qiubaifenbi(res.data.result.homeLeaseCount, res.data.result.homeCount));
						that.bfb2 =Number(that.qiubaifenbi(res.data.result.flatLeaseCount, res.data.result.flatCount));
						that.bfb3 =Number(that.qiubaifenbi(res.data.result.ensureLeaseCount, res.data.result.ensureCount));
						that.bfb4 =Number(that.qiubaifenbi(res.data.result.publicRentLeaseCount, res.data.result.publicRentCount));
					})
					.catch(function(error) {
						Message({message: error.data.message,type: 'error',}) //success   error
					});
			},
			
			
			//初始化资产情况总览
			getAllCertAssetCount() {
				var that = this;
				var urlss = localStorage.getItem('urlss');
				axios.post(urlss + '/dataV/getAllCertAssetCount', {})
					.then(function(res) {
						that.getAllCertAssetCountval = res.data.result;
					})
					.catch(function(error) {
						Message({message: error.data.message,type: 'error',}) //success   error
					});
			},
			
			//资产租赁情况
			getLeftAssetLeaseInfo() {
				var that = this;
				var urlss = localStorage.getItem('urlss');
				axios.post(urlss + '/dataV/getLeftAssetLeaseInfo', {})
					.then(function(res) {
						console.log(res)
						that.getLeftAssetLeaseInfoval = res.data.result;
					})
					.catch(function(error) {
						console.log(error)
						Message({message: error.data.message,type: 'error',}) //success   error
					});
			},

			//资产预警切换时加载数据？
			handleClick() {},
			
			//搜索
			sosofun(){
				var that =this;
				// 清除标记点
				for(var i = 0; i < that.smarkers.length;i++) {
				  that.smarkers[i].setMap(null);
				}
				// 清除聚合点
				that.smarkerCluster.clearMarkers();
				
				this.getAssetMap();
			},
			
			//获取所有坐标
			getAssetMap() {
				var that = this;
				
				var urlss = localStorage.getItem('urlss');
				var data = {
					'certTypeEnum': that.leixing_val,
					'stateEnum':that.lstatus_val,
					'keyWords':that.soso,
				};
				var options = {
					method: 'POST',
					headers: {
						'content-type': 'application/x-www-form-urlencoded'
					},
					data: qs.stringify(data),
					url: urlss + '/dataV/getAssetMap',
				};
				axios(options)
					
					.then(function(res) {
						//创建数据
						var mapdatas = [];
						for (let i = 0; i < res.data.result.length; i++) {
							if (res.data.result[i].position == '') {} else {
								var lng = res.data.result[i].position;
								var array = lng.split(',');
								mapdatas.push({
									id: res.data.result[i].assetId,
									name: res.data.result[i].name,
									type: res.data.result[i].type,
									state: res.data.result[i].state,
									lnglat: array
								})
							}
						}
						that.smarkers= []; //先清空不然翻倍
						// 遍历坐标点数组
						for (var i = 0; i < mapdatas.length; i++) {
							
							var contentcolor = '#d3d352';
							if (mapdatas[i]['state'] == 1) {
								var contentcolor = '#d3d352';
							} else {
								var contentcolor = 'Green';
							}
						    // 实例化一个标记点
						    var marker = new AMap.Marker({
						        position: mapdatas[i]['lnglat'], // 当前坐标点
						        content: '<div @click="clickMarker" ref="test" style="background-color: ' + contentcolor +
						        	'; padding: 10px; height: auto; width: auto; color:#fff; border-radius: 10px;">' + mapdatas[i]['name'] + '</div>',
						        offset: new AMap.Pixel(-15, -15)
						    });
							//点击
							// 给marker点坐标添加额外的属性和对应的属性值
							marker.setExtData(mapdatas[i])
							marker.on('click', that.clickMarker)
						    // 将标记点添加到地图中
						    that.smap.add(marker);
							that.smarkers.push(marker)
						}
						
						//添加聚合组件
						that.smap.plugin(["AMap.MarkerClusterer"], function() {
							console.log(that.smarkers)
							// 初始化聚合组件
							that.smarkerCluster = new AMap.MarkerClusterer(
							   		that.smap, // 地图实例
							   		that.smarkers, // 海量点组成的数组
							   		{
							   			gridSize: 80
							   		}
							   	);
						});
						
					})
					.catch(function(error) {
						// Message({message: error.data.message,type: 'error',}) //success   error
					});
			},

			
			//点击 标记点打开弹窗展示数据
			clickMarker(e) {
				this.getAssetDetails(e.target.getExtData().id)
			},
			
			
			// 求百分比
			qiubaifenbi(num, total) {
				/// <param name="num">当前数</param>
				/// <param name="total">总数</param>
				num = parseFloat(num);
				total = parseFloat(total);
				if (isNaN(num) || isNaN(total)) {
					return "-";
				}
				return total <= 0 ? "0" : (Math.round(num / total * 10000) / 100.00);
			},

		}
	}
</script>
<style>
	.zulin{
		position: relative;
	}
	.el-progress-bar__innerText{
		color: #000 !important;
	}
	.el-dialog__headerbtn{
		font-size: 44px;
	}
	.el-dialog__title{
		color: #fff !important;
	}
	.el-descriptions__title{
		color: #fff !important;
		padding: 10px 0;
	}
	.el-dialog__header{
		background-color: #385b91;
		color: #fff !important;
		border: 0px;
	}
	.el-dialog__body{
		background-color: #385b91 !important;
		color: #fff !important;
	}
	.el-select-dropdown, .el-autocomplete-suggestion {
	    border: 1px solid #106ae1 !important;
	    background-color: #385b91 !important;
	}
	.el-select-dropdown .el-select-dropdown__item, .el-autocomplete-suggestion .el-select-dropdown__item {
	    color: #fff;
	}
	.el-select-dropdown .el-select-dropdown__item.hover, .el-select-dropdown .el-select-dropdown__item:hover, .el-autocomplete-suggestion .el-select-dropdown__item.hover, .el-autocomplete-suggestion .el-select-dropdown__item:hover {
	    background-color: #106ae1;
	}
	.el-input__inner {
	    background-color: #385b91 !important;
	    border: 1px solid #409EFF;
	    color: #fff !important;
	}
	.el-tabs__item{
		color: #fff !important;
	}
	.el-tabs__active-bar{
		background-color: #409EFF !important;
	}
	.el-tabs__item.is-active {
	    color: #fff !important;
		text-align: center !important;
		background-color: #409EFF;
		padding:0 20px !important;
	}
	.el-table__header-wrapper th,tr, td {
	    background-color: #385b91 !important;
	    color: #fff !important;
	    border: 0px;
	}
	.el-table__body-wrapper::-webkit-scrollbar {
		display: none; /* Chrome Safari */
	}
	.el-table::-webkit-scrollbar {
		display: none; /* Chrome Safari */
	}
	.apptitle {
		display: block;
		width: 100%;
		color: #ffffff;
	}

	.zulin_baifenbi {
		text-align: right;
		width: 100%;
		display: block;
		height: 40px;
	}

	.zulin_baifenbi_title {
		position: absolute;
		left: 0;
		font-weight: normal;
		font-size: 14px;
		color: #ffffff;
	}

	.zulin_baifenbi_one {
		width: 40%;
		position: absolute;
		right: 0;
	}

	.zulin_title {
		text-align: right;
		font-size: 14px;
		font-weight: normal;
		padding: 10px 0;
		display: block;
		width: 100%;
		color: #ffffff;
	}
	.el-progress__text{
		color: #ffffff !important;
	}

	.zulin_title_val {
		color: #3ab9ee;
		font-size: 30px;
	}
	.liupai_val {
		float: right;
		color: #dfe110;
		font-weight: normal;
	}

	.liupai_name {
		font-weight: normal;
	}

	.liupai_one {
		width: 90%;
		height: 28px;
		margin-top: 12px;
		line-height: 28px;
		padding: 0 5%;
		background-color: #385b91;
		font-size: 16px;
		color: #23c3fe;
		text-align: left;
	}

	.zcqkzl_data_left_img5 {
		width: 70px;
		height: 70px;
		background-image: linear-gradient(35deg, #00577f 0%, #02c9c8 100%);
		position: absolute;
		left: 140px;
		top: 52px;
		border-radius: 100%;
		padding: 10px;
	}
	

	.zcyj {
		width: 400px;
		padding:20px 20px 40px 20px;
		height: 500px;
		background-color: #385b91 !important;
		color: #fff !important;
		position: fixed;
		top: 0;
		right: 0;
		z-index: 1;
		opacity: 0.9;
		font-size: 17px;
		font-weight: bold;
		overflow: hidden;
	}
	.shuzulvs{
		width: 360px;
		padding:20px 20px 40px 20px;
		background-color: #385b91 !important;
		height: 200px;
		color: #fff !important;
		z-index: 1;
		opacity: 0.9;
		font-size: 17px;
		font-weight: bold;
		overflow: hidden;
		margin-bottom: 20px;
	}
	.shuzulv{
			width: 400px;
			padding:20px 20px 40px 20px;
			background-color: #385b91 !important;
			height: 200px;
			color: #fff !important;
			position: fixed;
			top: 580px;
			right: 0;
			z-index: 1;
			font-size: 17px;
			font-weight: bold;
			overflow: hidden;
			opacity: 0.9;
	}

	.zcqkzlyyzx {
		width: 900px;
		padding: 20px;
		height: 120px;
		/* background-color: #fff; */
		position: fixed;
		top: 0;
		left: 440px;
		z-index: 1;
		/* opacity: 0.4; */
		color: #fff;
		font-size: 17px;
		font-weight: bold;
	}

	.zcqkzl {
		width: 400px;
		padding: 20px;
		height: 620px;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1;
		color: #fff;
		font-size: 17px;
		font-weight: bold;
	}

	.zcqkzl_data_left_val {
		font-size: 26px;
		line-height: 24px;
		letter-spacing: 0px;
		color: #ffffff;
		display: block;
		padding-top: 20px;
	}

	.zcqkzl_data_left_title {
		font-size: 14px;
		line-height: 24px;
		letter-spacing: 0px;
		color: #fff;
		font-weight: normal;
		display: block;
	}

	.zcqkzl_data_left {
		width: 157px;
		height: 79px;
		float: left;
		margin: 4px;
		text-align: center;
	}

	.zcqkzl_data {
		width: 100%;
		height: 200px;
		/* background-color: #fff; */
		/* opacity: 0.1; */
		position: relative;

	}

	.zcqkzl_data_left_img1 {
		background: url('../../assets/1.png') no-repeat;
		background-size: 100% 100%;
	}

	.zcqkzl_data_left_img2 {
		background: url('../../assets/2.png') no-repeat;
		background-size: 100% 100%;
	}

	.zcqkzl_data_left_img3 {
		background: url('../../assets/3.png') no-repeat;
		background-size: 100% 100%;
	}

	.zcqkzl_data_left_img4 {
		background: url('../../assets/4.png') no-repeat;
		background-size: 100% 100%;
	}

	* {
		padding: 0;
		margin: 0;
	}

	#container {
		width: 100%;
		height: 100vh;
		padding: 0;
		margin: 0;
	}

	::v-deep .marker-route {
		width: 60px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		background-color: red;
	}

	.el-range-editor.is-active,
	.el-range-editor.is-active:hover,
	.el-select .el-input.is-focus .el-input__inner {
		border-color: #409EFF;
	}
</style>
